import app from '@src/helpers/app';
import {ObjectKeys} from '@src/@types/ObjectKeys';
import {IRequestParam} from '@src/@interfaces/services/URLGenerator/IRequestParam';

export default abstract class AbstractRoute<Route> {
    protected name: string | null = null;

    constructor(attributes: ObjectKeys<Route>) {
        this.fill(attributes);
    }

    getName(): string | null {
        return this.name;
    }

    setName(name: string): void {
        this.name = name;
    }

    getParamsFromUrl(url: string): IRequestParam[] {
        return this.url.getRequestParams(url, this.getRouteUri());
    }

    resolveUrl(params?: (string | number)[] | Record<string, string | number>): string {
        return this.url.generate(this.getRouteUri(), params || {});
    }

    resolveAbsoluteUrl(params?: (string | number)[] | Record<string, string | number>): string {
        return this.url.toAbsoluteURL(
            this.resolveUrl(params)
        );
    }

    fill(attributes: ObjectKeys<Route>): void {
        Object.assign(this, attributes);
    }

    protected abstract getRouteUri(): string;

    protected get url() {
        return app('url');
    }
}
